"use client";

import {
  TimePicker,
  TimePickerContent,
  TimePickerHour,
  TimePickerInput,
  TimePickerInputGroup,
  TimePickerMinute,
  TimePickerPeriod,
  TimePickerSeparator,
  TimePickerTrigger,
} from "@/components/ui/time-picker";
import { Field, FieldError, FieldLabel } from "./field-wrapper";
import type { FieldBindingProps } from "./types";

export interface TimePickerFieldProps extends FieldBindingProps<string> {
  label?: string;
  minuteStep?: number;
  disabled?: boolean;
  isRequired?: boolean;
}

export function TimePickerField({
  value,
  onChange,
  onBlur,
  errors,
  isTouched,
  isRequired,
  label,
  minuteStep = 1,
  disabled,
}: TimePickerFieldProps) {
  return (
    <Field errors={errors} isTouched={isTouched} isRequired={isRequired}>
      {label && <FieldLabel>{label}</FieldLabel>}
      <div className={label ? "mt-1" : ""}>
        <TimePicker
          value={value}
          onValueChange={(v) => {
            onChange(v);
            onBlur();
          }}
          minuteStep={minuteStep}
          disabled={disabled}
        >
          <TimePickerInputGroup>
            <TimePickerInput segment="hour" />
            <TimePickerSeparator />
            <TimePickerInput segment="minute" />
            <TimePickerInput segment="period" />
            <TimePickerTrigger />
          </TimePickerInputGroup>
          <TimePickerContent>
            <TimePickerHour />
            <TimePickerMinute />
            <TimePickerPeriod />
          </TimePickerContent>
        </TimePicker>
      </div>
      <FieldError />
    </Field>
  );
}
